import { useEffect, useMemo, useRef } from 'react';

const useIsMounted = () => {
  const isMountedFlagRef = useRef(true);

  useEffect(() => {
    isMountedFlagRef.current = true; // only here for strict mode, redundant otherwise

    return () => {
      isMountedFlagRef.current = false;
    };
  }, []);

  return useMemo(
    () => ({
      isMountedRef: isMountedFlagRef,
    }),
    [],
  );
};

export default useIsMounted;
